import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Radio,
  Button,
  Grid,
  Dropdown,
  Segment,
  Label
} from 'semantic-ui-react';
import _ from 'lodash';
import { userConstants } from '../../constants/user.constants';
import { userActions } from '../../actions/user.actions';
import { settingsActions } from '../../actions/settings.actions';
import PropTypes from 'prop-types';
import { getBlockModeLabel, getJourneyModeLabel, getTrileanLabel, getApprovalStepTypeLabel } from '../../helpers/user';

class GroupFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      group: {
        name: '',
        description: '',
        journeyMode: userConstants.JOURNEY_MODE_NOT_CONFIGURED,
        blockMode: userConstants.BLOCK_MODE_NOT_CONFIGURED,
        autoCreateUsers: true,
        syncManager: true,
        syncPersonalData: true,
        labels: [],
        members: [],
        approvers: [],
        active: true,
        azureAdId: '',
        customApprovalWorkflow: false,
        approvalWorkflowPriority: 0,
        approvalRules: [],
        workflowApprovalNotificationEmails: '',
        maxMinutesRequest: '',
        allowOverrideMaxMinutesManager: userConstants.TRILEAN_NOT_CONFIGURED,
      },
      search: '',
      searchManager: '',    
      errors: {},
      showRepeat: false,
      submitted: false,
      loadingSync: false,
      labelOptions: [],
      selectedApproverOptions: [],
      selectedMemberOptions: [],
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    this.handleSearchDebounced = _.debounce(function() {
      this.fetchUsers();
    }, 500);

    this.handleSearchManagerDebounced = _.debounce(function() {
      this.fetchManagers();
    }, 500);

    if (match.params.id) {
      dispatch(userActions.getGroup(match.params.id))
        .then(() => {
          const group = _.mapKeys(this.props.group, function (v, k) { return k[0].toLowerCase() + k.substring(1); });
          const labelOptions = group.labels.map((label) => ({ key: label.Label, text: label.Label, value: label.Label }));
          const selectedMemberOptions = group.users.filter((user) => user.Type == 1).map((user) => ({ key: user.User.Id, text: user.User.Name, value: user.User.Id}));
          const selectedApproverOptions = group.users.filter((user) => user.Type == 2).map((user) => ({ key: user.User.Id, text: user.User.Name, value: user.User.Id}));
          group.labels = group.labels.map((label) => label.Label);
          group.members = group.users.filter((user) => user.Type == 1).map((user) => user.User.Id);
          group.approvers = group.users.filter((user) => user.Type == 2).map((user) => user.User.Id);
          group.approvalRules = (group.approvalRules || [])
            .sort((a, b) => a.Order - b.Order)
            .map((rule) => ({
              typeLabel: rule.TypeLabel || '',
              maxMinutes: rule.MaxMinutes || '',
              steps: (rule.Steps || [])
                .sort((a, b) => a.Order - b.Order)
                .map((step) => ({ type: step.Type, approverGroupId: step.ApproverGroupId, sendEmail: step.SendEmail })),
            }));
          group.maxMinutesRequest = group.maxMinutesRequest || '';
          group.allowOverrideMaxMinutesManager = group.allowOverrideMaxMinutesManager != null ? group.allowOverrideMaxMinutesManager : userConstants.TRILEAN_NOT_CONFIGURED;
          group.defaultWorkSchedules.forEach((item) => {
            var suffix = '_' + item.WeekDay;
            group['start' + suffix] = item.StartTime.Hours + ':' + item.StartTime.Minutes;
            group['work' + suffix] = item.WorkMinutes;
            group['lunch' + suffix] = item.LunchMinutes;
            group['start_tolerance' + suffix] = item.StartToleranceMinutes;
            group['end_tolerance' + suffix] = item.EndToleranceMinutes;
          });

          this.setState({ group, labelOptions, selectedMemberOptions, selectedApproverOptions })
        });
    }

    dispatch(userActions.fetch({ orderBy: "Name" }));
    // Options for the "approvers of a group" steps of the approval chain
    dispatch(userActions.fetchGroups({ active: true, orderBy: "Name", pageSize: 500 }));
    // Global settings supply the request categories used by the per-category rules
    dispatch(settingsActions.fetchGlobal());
  }

  fetchUsers() {
    const { dispatch } = this.props;
    const { search } = this.state;
    dispatch(userActions.fetch({ search, orderBy: "Name" }));
  }

  fetchManagers() {
      const { dispatch } = this.props;
      const { searchManager } = this.state;      
      dispatch(userActions.managers({ search: searchManager, orderBy: "Name" }));
  }

  static get propTypes() {
    return {
      me: PropTypes.any,
      usersLoading: PropTypes.bool,
      loading: PropTypes.bool,
      group: PropTypes.any,
      groups: PropTypes.any,
      settings: PropTypes.any,
      match: PropTypes.any,
      users: PropTypes.any,
      loadingSync: PropTypes.bool,
    };
  }

  syncAzureAd() {
    if (confirm('Sincronizar os usuários do grupo com o Azure AD?')) {
      const { dispatch } = this.props;
      const { group } = this.state;
      dispatch(userActions.syncGroupAzureAd(group.id));
    }
  }

  syncAd() {
    if (confirm('Sincronizar os usuários do grupo com o AD?')) {
      const { dispatch } = this.props;
      const { group } = this.state;
      dispatch(userActions.syncGroupAd(group.id));
    }
  }

  simpleSearch(options, query) {
    query = query.toLowerCase();
    return options.filter(opt => {
      return opt.description && (opt.text.toLowerCase().indexOf(query) >= 0 || opt.description.toLowerCase().indexOf(query) >= 0);
    });
  }

  handleChange(field, data) {    
    const { group } = this.state;
    group[field] = data;    
    this.setState({ group });
  }

  handleUserSearchChange(search) {
    this.setState({ search });
    this.handleSearchDebounced();
  }

  parseEmailList(emails) {
    if (!emails) {
      return [];
    }

    return emails.split(',').map((email) => email.trim()).filter((email) => email.length > 0);
  }

  addApprovalRule() {
    const { group } = this.state;
    const approvalRules = (group.approvalRules || []).slice();
    approvalRules.push({
      typeLabel: '',
      maxMinutes: '',
      steps: [{ type: userConstants.APPROVAL_STEP_IMMEDIATE_SUPERIOR, approverGroupId: null, sendEmail: true }],
    });
    this.handleChange("approvalRules", approvalRules);
  }

  removeApprovalRule(ruleIndex) {
    const { group } = this.state;
    const approvalRules = (group.approvalRules || []).slice();
    approvalRules.splice(ruleIndex, 1);
    this.handleChange("approvalRules", approvalRules);
  }

  handleApprovalRuleChange(ruleIndex, field, value) {
    const { group } = this.state;
    const approvalRules = (group.approvalRules || []).slice();
    approvalRules[ruleIndex] = Object.assign({}, approvalRules[ruleIndex], { [field]: value });
    this.handleChange("approvalRules", approvalRules);
  }

  updateRuleSteps(ruleIndex, steps) {
    const { group } = this.state;
    const approvalRules = (group.approvalRules || []).slice();
    approvalRules[ruleIndex] = Object.assign({}, approvalRules[ruleIndex], { steps });
    this.handleChange("approvalRules", approvalRules);
  }

  addApprovalStep(ruleIndex) {
    const steps = (this.state.group.approvalRules[ruleIndex].steps || []).slice();
    steps.push({ type: userConstants.APPROVAL_STEP_IMMEDIATE_SUPERIOR, approverGroupId: null, sendEmail: true });
    this.updateRuleSteps(ruleIndex, steps);
  }

  removeApprovalStep(ruleIndex, stepIndex) {
    const steps = (this.state.group.approvalRules[ruleIndex].steps || []).slice();
    steps.splice(stepIndex, 1);
    this.updateRuleSteps(ruleIndex, steps);
  }

  moveApprovalStep(ruleIndex, stepIndex, offset) {
    const steps = (this.state.group.approvalRules[ruleIndex].steps || []).slice();
    const target = stepIndex + offset;
    if (target < 0 || target >= steps.length) {
      return;
    }

    const moved = steps[stepIndex];
    steps[stepIndex] = steps[target];
    steps[target] = moved;
    this.updateRuleSteps(ruleIndex, steps);
  }

  handleApprovalStepChange(ruleIndex, stepIndex, field, value) {
    const steps = (this.state.group.approvalRules[ruleIndex].steps || []).slice();
    const step = Object.assign({}, steps[stepIndex], { [field]: value });

    // The group only matters for a "approvers of a group" step
    if (field == "type" && value != userConstants.APPROVAL_STEP_GROUP_APPROVERS) {
      step.approverGroupId = null;
    }

    steps[stepIndex] = step;
    this.updateRuleSteps(ruleIndex, steps);
  }

  typeLabelOptions() {
    const { settings } = this.props;
    // Same raw split the request form uses, so a rule's category matches a request's category exactly
    const options = [{ key: '__default', value: '', text: 'Padrão do grupo (qualquer categoria)' }];
    if (settings && settings.RequestTypes) {
      settings.RequestTypes.split("\n").filter((t) => t.length > 0).forEach((t) => {
        options.push({ key: t, value: t, text: t });
      });
    }
    return options;
  }

  approvalStepTypeOptions() {
    return [
      {key: userConstants.APPROVAL_STEP_IMMEDIATE_SUPERIOR, value: userConstants.APPROVAL_STEP_IMMEDIATE_SUPERIOR, text: getApprovalStepTypeLabel(userConstants.APPROVAL_STEP_IMMEDIATE_SUPERIOR)},
      {key: userConstants.APPROVAL_STEP_MEDIATE_SUPERIOR, value: userConstants.APPROVAL_STEP_MEDIATE_SUPERIOR, text: getApprovalStepTypeLabel(userConstants.APPROVAL_STEP_MEDIATE_SUPERIOR)},
      {key: userConstants.APPROVAL_STEP_GROUP_APPROVERS, value: userConstants.APPROVAL_STEP_GROUP_APPROVERS, text: getApprovalStepTypeLabel(userConstants.APPROVAL_STEP_GROUP_APPROVERS)},
    ];
  }

  approverGroupOptions() {
    const { groups } = this.props;

    if (!groups || !groups.Results) {
      return [];
    }

    // The group itself is a valid choice: it is how the current default behaviour works
    return groups.Results.map((item) => ({ key: item.Id, text: item.Name, description: item.Description, value: item.Id }));
  }

  handleManagerSearchChange(searchManager) {
    this.setState({ searchManager });
    this.handleSearchManagerDebounced();
  }

  validate() {
    const { group } = this.state;

    let errors = {};
    let valid = true;

    if (!group.name || group.name.length == 0) {
      errors.name = "Preencha o nome";
      valid = false;
    }

    if (!group.description || group.description.length == 0) {
      errors.description = "Preencha a descrição";
      valid = false;
    }

    if (group.customApprovalWorkflow) {
      const rules = group.approvalRules || [];
      if (rules.length == 0) {
        errors.approvalRules = "Adicione ao menos uma regra de aprovação";
        valid = false;
      }

      const ruleKeys = new Set();
      rules.forEach((rule) => {
        const steps = rule.steps || [];
        if (steps.length == 0) {
          errors.approvalRules = "Cada regra precisa de ao menos uma etapa";
          valid = false;
        }

        if (steps.some((step) => step.type == userConstants.APPROVAL_STEP_GROUP_APPROVERS && !step.approverGroupId)) {
          errors.approvalRules = "Selecione o grupo aprovador de cada etapa por grupo";
          valid = false;
        }

        const stepKeys = steps.map((step) => step.type + ':' + (step.approverGroupId || ''));
        if (new Set(stepKeys).size != stepKeys.length) {
          errors.approvalRules = "Há etapas repetidas em uma regra";
          valid = false;
        }

        if (rule.maxMinutes !== '' && rule.maxMinutes != null && (isNaN(rule.maxMinutes) || parseInt(rule.maxMinutes) < 0)) {
          errors.approvalRules = "Tempo máximo da regra inválido";
          valid = false;
        }

        // Null and zero both mean "no upper bound", so they collapse to the same key
        const normalizedMax = (rule.maxMinutes && parseInt(rule.maxMinutes) > 0) ? parseInt(rule.maxMinutes) : 0;
        const key = (rule.typeLabel || '') + ':' + normalizedMax;
        if (ruleKeys.has(key)) {
          errors.approvalRules = "Há regras repetidas para a mesma categoria e tamanho";
          valid = false;
        }
        ruleKeys.add(key);
      });

      if (group.maxMinutesRequest !== '' && group.maxMinutesRequest != null && (isNaN(group.maxMinutesRequest) || parseInt(group.maxMinutesRequest) < 0)) {
        errors.maxMinutesRequest = "Valor inválido";
        valid = false;
      }

      const invalidEmails = this.parseEmailList(group.workflowApprovalNotificationEmails)
        .filter((email) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
      if (invalidEmails.length > 0) {
        errors.workflowApprovalNotificationEmails = `E-mail inválido: ${invalidEmails.join(', ')}`;
        valid = false;
      }
    }

    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { group } = this.state;

    let payload = Object.assign({}, group);
    payload.requesters = payload.members;
    if (group.azureAdSync || group.adSync) {
      payload.requesters = null;
      payload.members = null;
      payload.users = null;
    }

    const workSchedule = [];
    for (let i = 0; i < 7; i++) {
      const suffix = '_' + i;
      if (group['start' + suffix]) {
        workSchedule.push({ 
          WeekDay: i,
          StartTime: group['start' + suffix],
          WorkMinutes: parseInt(group['work' + suffix]),
          LunchMinutes: parseInt(group['lunch' + suffix]),
          StartToleranceMinutes: parseInt(group['start_tolerance' + suffix]),
          EndToleranceMinutes: parseInt(group['end_tolerance' + suffix]),
        });
      }    
    }    
    payload.workSchedule = workSchedule;

    // The order of the rules and of the steps within each rule is preserved; the backend renumbers it
    payload.approvalRules = group.customApprovalWorkflow
      ? (group.approvalRules || []).map((rule) => ({
          TypeLabel: rule.typeLabel || null,
          MaxMinutes: (rule.maxMinutes === '' || rule.maxMinutes == null) ? null : parseInt(rule.maxMinutes),
          Steps: (rule.steps || []).map((step) => ({
            Type: step.type,
            ApproverGroupId: step.type == userConstants.APPROVAL_STEP_GROUP_APPROVERS ? step.approverGroupId : null,
            SendEmail: step.sendEmail,
          })),
        }))
      : [];
    payload.approvalWorkflowPriority = parseInt(group.approvalWorkflowPriority) || 0;
    payload.workflowApprovalNotificationEmails = this.parseEmailList(group.workflowApprovalNotificationEmails).join(',');
    payload.maxMinutesRequest = (group.customApprovalWorkflow && group.maxMinutesRequest !== '' && group.maxMinutesRequest != null) ? parseInt(group.maxMinutesRequest) : null;
    payload.allowOverrideMaxMinutesManager = group.customApprovalWorkflow ? group.allowOverrideMaxMinutesManager : userConstants.TRILEAN_NOT_CONFIGURED;

    if (group.id) {
      dispatch(userActions.updateGroup(group.id, payload));
    } else {
      dispatch(userActions.createGroup(payload));      
    }
  }

  blockModeOptions() {
    return [
      {key: userConstants.BLOCK_MODE_NOT_CONFIGURED, value: userConstants.BLOCK_MODE_NOT_CONFIGURED, text: getBlockModeLabel(userConstants.BLOCK_MODE_NOT_CONFIGURED)},
      {key: userConstants.BLOCK_MODE_AUTO, value: userConstants.BLOCK_MODE_AUTO, text: getBlockModeLabel(userConstants.BLOCK_MODE_AUTO)},
      {key: userConstants.BLOCK_MODE_ENABLED, value: userConstants.BLOCK_MODE_ENABLED, text: getBlockModeLabel(userConstants.BLOCK_MODE_ENABLED)},
      {key: userConstants.BLOCK_MODE_DISABLED, value: userConstants.BLOCK_MODE_DISABLED, text: getBlockModeLabel(userConstants.BLOCK_MODE_DISABLED)},
    ]
  }

  journeyModeOptions() {
    return [
      {key: userConstants.JOURNEY_MODE_NOT_CONFIGURED, value: userConstants.JOURNEY_MODE_NOT_CONFIGURED, text: getJourneyModeLabel(userConstants.JOURNEY_MODE_NOT_CONFIGURED)},
      {key: userConstants.JOURNEY_MODE_FLEXIBLE, value: userConstants.JOURNEY_MODE_FLEXIBLE, text: getJourneyModeLabel(userConstants.JOURNEY_MODE_FLEXIBLE)},
      {key: userConstants.JOURNEY_MODE_RIGID, value: userConstants.JOURNEY_MODE_RIGID, text: getJourneyModeLabel(userConstants.JOURNEY_MODE_RIGID)},
    ]
  }

  trileanOptions() {
    return [
      {key: userConstants.TRILEAN_NOT_CONFIGURED, value: userConstants.TRILEAN_NOT_CONFIGURED, text: getTrileanLabel(userConstants.TRILEAN_NOT_CONFIGURED)},
      {key: userConstants.TRILEAN_TRUE, value: userConstants.TRILEAN_TRUE, text: getTrileanLabel(userConstants.TRILEAN_TRUE)},
      {key: userConstants.TRILEAN_FALSE, value: userConstants.TRILEAN_FALSE, text: getTrileanLabel(userConstants.TRILEAN_FALSE)},
    ]
  }

  render() {
    const { loading, usersLoading, users, managers, me } = this.props;
    const { group, errors, labelOptions, selectedApproverOptions, selectedMemberOptions } = this.state;

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN && me.Role != userConstants.ROLE_USER_MANAGER) {
      window.location.href = "/";
      return;
    }

    const inputModeOptions = [
      { key: 0, value: 0, text: "Não Configurado" },
      { key: 1, value: 1, text: "Integração" },
      { key: 2, value: 2, text: "Login" },
      { key: 3, value: 3, text: "Integração e Login" },
    ];

    let approverOptions = selectedApproverOptions;
    let selectedApproverKeys = selectedApproverOptions.map((item) => item.key);    
    let memberOptions = selectedMemberOptions;
    let selectedMemberKeys = selectedMemberOptions.map((item) => item.key);

    if (users && users.Results) {      
      users.Results.forEach((user) => {
        if (!selectedApproverKeys.includes(user.Id)) {          
          approverOptions.push({ key: user.Id, text: user.Name, description: user.Email, value: user.Id });
        }
        if (!selectedMemberKeys.includes(user.Id)) {          
          memberOptions.push({ key: user.Id, text: user.Name, description: user.Email, value: user.Id });
        }
      })
    }

    if (managers && managers.Results) {      
      managers.Results.forEach((user) => {
        if (!selectedApproverKeys.includes(user.Id)) {          
          approverOptions.push({ key: user.Id, text: user.Name, description: user.Email, value: user.Id });
        }        
      });
    }

    const syncButtonStyle = { marginLeft: 16, marginTop: -4 };
    
    return (
      <Fragment>
        <h1>Grupo</h1>
        <Form loading={loading} onSubmit={() => this.handleSubmit()}>
          <Form.Input required error={errors.title} label='Nome' value={group.name} name='name' type='text' onChange={(e, data) => this.handleChange("name", data.value)} placeholder='Nome do grupo' />
          { errors.name && <Label color='red'>{errors.name}</Label>}

          <Form.TextArea required error={errors.description} label='Descrição' value={group.description} name='description' onChange={(e, data) => this.handleChange("description", data.value)} type='textarea' placeholder='Descreva por que precisa das horas adicionais' />
          { errors.description && <Label color='red'>{errors.description}</Label>}
        
          <Form.Input>
            <Radio toggle checked={group.active} label='Habilitado' onChange={(e, data) => this.handleChange("active", data.checked)} />
          </Form.Input>
        
          <Form.Input>
            <Radio toggle checked={group.azureAdSync} label='Sincronizar com Azure AD' onChange={(e, data) => this.handleChange("azureAdSync", data.checked)} />
            {group.id && <Button 
              onClick={() => this.syncAzureAd()} 
              icon='refresh' 
              type='button' 
              size='mini'               
              title='Sincronizar agora'
              circular
              loading={this.props.loadingSync}
              disabled={!group.azureAdSync}
              style={syncButtonStyle} />}    
          </Form.Input>

          <Form.Input disabled={!group.azureAdSync} error={errors.azureAdId} label='ID Azure AD' value={group.azureAdId} azureAdId='azureAdId' type='text' onChange={(e, data) => this.handleChange("azureAdId", data.value)} placeholder='ID do grupo no Azure AD' />
          { errors.azureAdId && <Label color='red'>{errors.azureAdId}</Label>}

          <Form.Input>
            <Radio toggle checked={group.adSync} label='Sincronizar com AD' onChange={(e, data) => this.handleChange("adSync", data.checked)} />
            {group.id && <Button 
              onClick={() => this.syncAd()} 
              icon='refresh' 
              type='button' 
              size='mini'               
              title='Sincronizar agora'
              circular
              loading={this.props.loadingSync}
              disabled={!group.adSync}
              style={syncButtonStyle} />}    
          </Form.Input>

          <Form.Input disabled={!group.adSync} error={errors.adName} label='Nome Grupo AD' value={group.adName} id='adName' type='text' onChange={(e, data) => this.handleChange("adName", data.value)} placeholder='Nome do Grupo no AD' />
          { errors.adName && <Label color='red'>{errors.adName}</Label>}          

          <Form.Field disabled={group.azureAdSync || group.adSync}>
            <label>Membros</label>
            <Dropdown
              placeholder='Digite nome, usuário ou e-mail'
              fluid
              multiple
              selection
              loading={usersLoading}
              onChange={(e, data) => this.handleChange("members", data.value)}
              onSearchChange={(e, data) => this.handleUserSearchChange(data.searchQuery)}
              search={(opt, qry) => this.simpleSearch(opt, qry)}
              value={group.members || []}
              options={memberOptions}
            />
            { errors.members && <Label basic pointing  color='red'>{errors.members}</Label>}
          </Form.Field>
        
          <Form.Field>
            <label>Aprovadores</label>
            <Dropdown
              placeholder='Digite nome, usuário ou e-mail'
              fluid
              multiple
              selection
              loading={usersLoading}
              onChange={(e, data) => this.handleChange("approvers", data.value)}
              onSearchChange={(e, data) => this.handleManagerSearchChange(data.searchQuery)}
              search={(opt, qry) => this.simpleSearch(opt, qry)}              
              options={approverOptions}
              value={group.approvers || []}
            />
            { errors.approvers && <Label basic pointing  color='red'>{errors.approvers}</Label>}            
            <small style={{ color: 'grey', display: 'block' }}>Somente usuários com perfis: Gestor, Aprovador e Administrador são exibidos.</small>
          </Form.Field>          

          <Form.Field>
            <Radio toggle checked={group.defaultApproverGroup} label='Direcionar Aprovações sem Gestor para este grupo' onChange={(e, data) => this.handleChange("defaultApproverGroup", data.checked)} />
          </Form.Field>

          <h3>Fluxo de Aprovação</h3>
          <p>
            Quando habilitado, as solicitações criadas pelos membros deste grupo seguem uma das regras
            abaixo, escolhida pela categoria e pelo tamanho da solicitação. Os demais usuários continuam
            seguindo as configurações globais.
          </p>

          <Form.Field>
            <Radio toggle checked={!!group.customApprovalWorkflow} label='Usar Fluxo de Aprovação Personalizado' onChange={(e, data) => this.handleChange("customApprovalWorkflow", data.checked)} />
          </Form.Field>

          {group.customApprovalWorkflow && <Fragment>
            <Form.Input
              label='Prioridade do Fluxo'
              value={group.approvalWorkflowPriority || 0}
              name='approvalWorkflowPriority'
              type='number'
              onChange={(e, data) => this.handleChange("approvalWorkflowPriority", data.value)}
            />
            <p>Usada quando o membro está em mais de um grupo com fluxo personalizado: vence o de maior prioridade.</p>

            <Form.Group widths='equal'>
              <Form.Input
                error={!!errors.maxMinutesRequest}
                label='Tempo Máximo por Solicitação (minutos)'
                value={group.maxMinutesRequest}
                name='maxMinutesRequest'
                type='number'
                min='0'
                placeholder='Vazio = usar configuração global'
                onChange={(e, data) => this.handleChange("maxMinutesRequest", data.value)}
              />
              <Form.Field>
                <label>Permitir Gestor Exceder o Tempo Máximo</label>
                <Dropdown
                  fluid
                  selection
                  options={this.trileanOptions()}
                  value={group.allowOverrideMaxMinutesManager}
                  onChange={(e, data) => this.handleChange("allowOverrideMaxMinutesManager", data.value)}
                />
              </Form.Field>
            </Form.Group>
            { errors.maxMinutesRequest && <Label basic pointing color='red'>{errors.maxMinutesRequest}</Label>}
            <p>Substituem as configurações globais de tempo máximo para os membros deste grupo. &quot;Não Alterar&quot; mantém o global.</p>

            <Form.Input
              error={!!errors.workflowApprovalNotificationEmails}
              label='E-mails Notificados na Aprovação'
              value={group.workflowApprovalNotificationEmails || ''}
              name='workflowApprovalNotificationEmails'
              type='text'
              onChange={(e, data) => this.handleChange("workflowApprovalNotificationEmails", data.value)}
              placeholder='Separe os e-mails por vírgula'
            />
            { errors.workflowApprovalNotificationEmails && <Label basic pointing color='red'>{errors.workflowApprovalNotificationEmails}</Label>}
            <p>Notificados quando uma solicitação que seguiu o fluxo deste grupo é aprovada.</p>

            <h4>Regras</h4>
            <p>
              Uma regra sem categoria é o padrão do grupo. Uma regra com &quot;até X minutos&quot; só vale para
              solicitações desse tamanho; deixe em branco para valer sem limite de tempo.
            </p>
            { errors.approvalRules && <Label basic pointing color='red'>{errors.approvalRules}</Label>}

            {(group.approvalRules || []).map((rule, ruleIndex) => (
              <Segment key={ruleIndex}>
                <Grid verticalAlign='bottom'>
                  <Grid.Row>
                    <Grid.Column width={7}>
                      <label>Categoria</label>
                      <Dropdown
                        fluid
                        selection
                        options={this.typeLabelOptions()}
                        value={rule.typeLabel || ''}
                        onChange={(e, data) => this.handleApprovalRuleChange(ruleIndex, "typeLabel", data.value)}
                      />
                    </Grid.Column>
                    <Grid.Column width={6}>
                      <Form.Input
                        label='Até (minutos)'
                        type='number'
                        min='0'
                        value={rule.maxMinutes}
                        placeholder='Sem limite'
                        onChange={(e, data) => this.handleApprovalRuleChange(ruleIndex, "maxMinutes", data.value)}
                      />
                    </Grid.Column>
                    <Grid.Column width={3} textAlign='right'>
                      <Button icon='trash' type='button' size='mini' circular negative title='Remover regra' onClick={() => this.removeApprovalRule(ruleIndex)} />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

                <Grid verticalAlign='middle'>
                  {(rule.steps || []).map((step, stepIndex) => (
                    <Grid.Row key={stepIndex}>
                      <Grid.Column width={1}>
                        <Label circular>{stepIndex + 1}</Label>
                      </Grid.Column>
                      <Grid.Column width={5}>
                        <Dropdown
                          fluid
                          selection
                          options={this.approvalStepTypeOptions()}
                          value={step.type}
                          onChange={(e, data) => this.handleApprovalStepChange(ruleIndex, stepIndex, "type", data.value)}
                        />
                      </Grid.Column>
                      <Grid.Column width={5}>
                        {step.type == userConstants.APPROVAL_STEP_GROUP_APPROVERS && <Dropdown
                          placeholder='Selecione o grupo aprovador'
                          fluid
                          search
                          selection
                          options={this.approverGroupOptions()}
                          value={step.approverGroupId || null}
                          onChange={(e, data) => this.handleApprovalStepChange(ruleIndex, stepIndex, "approverGroupId", data.value)}
                        />}
                      </Grid.Column>
                      <Grid.Column width={2}>
                        <Radio toggle checked={!!step.sendEmail} label='E-mail' onChange={(e, data) => this.handleApprovalStepChange(ruleIndex, stepIndex, "sendEmail", data.checked)} />
                      </Grid.Column>
                      <Grid.Column width={3} textAlign='right'>
                        <Button icon='arrow up' type='button' size='mini' circular title='Subir etapa' disabled={stepIndex == 0} onClick={() => this.moveApprovalStep(ruleIndex, stepIndex, -1)} />
                        <Button icon='arrow down' type='button' size='mini' circular title='Descer etapa' disabled={stepIndex == rule.steps.length - 1} onClick={() => this.moveApprovalStep(ruleIndex, stepIndex, 1)} />
                        <Button icon='trash' type='button' size='mini' circular negative title='Remover etapa' onClick={() => this.removeApprovalStep(ruleIndex, stepIndex)} />
                      </Grid.Column>
                    </Grid.Row>
                  ))}
                </Grid>

                <Button type='button' size='small' icon='plus' content='Adicionar Etapa' onClick={() => this.addApprovalStep(ruleIndex)} style={{ marginTop: 8 }} />
              </Segment>
            ))}

            <Form.Field style={{ marginTop: 8 }}>
              <Button type='button' primary size='small' icon='plus' content='Adicionar Regra' onClick={() => this.addApprovalRule()} />
            </Form.Field>
          </Fragment>}

          <Form.Field>
            <label>Labels</label>
            <Dropdown
              placeholder='Digite suas labels para integração com sistemas externos'
              fluid
              multiple
              search
              selection
              allowAdditions
              onChange={(e, data) => this.handleChange("labels", data.value)}                            
              onAddItem={(event, data) => { labelOptions.push({key: data.value, text: data.value, value: data.value}); this.setState({ labelOptions }) }}
              options={labelOptions}       
              value={group.labels || []}       
            />
            { errors.labels && <Label basic pointing  color='red'>{errors.labels}</Label>}
          </Form.Field>    

          <Form.Field required>
            <label>Modo Bloqueio</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              label='Modo de Bloqueio'
              selection
              value={group.blockMode} 
              onChange={(e, data) => this.handleChange("blockMode", data.value)}
              options={this.blockModeOptions()}
            />
            { errors.blockMode && <Label basic pointing color='red'>{errors.blockMode}</Label>}
        </Form.Field>

        <Form.Field required>
          <label>Entrada de Registro de Ponto</label>
          <Dropdown
            placeholder='Selecione'
            fluid
            selection
            onChange={(e, data) => this.handleChange("clockRegisterInput", data.value)}
            options={inputModeOptions}
            value={group.clockRegisterInput}
          />
          { errors.clockRegisterInput && <Label basic pointing  color='red'>{errors.clockRegisterInput}</Label>}
        </Form.Field>

        <Form.Field>
          <Radio toggle checked={group.disableRemovedUsers} label='Desativar Bloqueio Usuários Removidos' onChange={(e, data) => this.handleChange("disableRemovedUsers", data.checked)} />
        </Form.Field>

        <Form.Field required>
            <label>Modo Jornada</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              label='Modo de Jornada'
              selection
              value={group.journeyMode} 
              onChange={(e, data) => this.handleChange("journeyMode", data.value)}
              options={this.journeyModeOptions()}
            />
            { errors.blockMode && <Label basic pointing color='red'>{errors.blockMode}</Label>}
        </Form.Field>        

        <Form.Field required>
            <label>Auto Aprovação</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              label='Auto Aprovação'
              selection
              value={group.allowSelfApproval} 
              onChange={(e, data) => this.handleChange("allowSelfApproval", data.value)}
              options={this.trileanOptions()}
            />
            { errors.allowSelfApproval && <Label basic pointing color='red'>{errors.allowSelfApproval}</Label>}
        </Form.Field>       

        <Form.Input required error={errors.title} label='Tolerância Adicional Entrada' value={group.toleranceStartMinutes} name='toleranceStartMinutes' type='number' onChange={(e, data) => this.handleChange("toleranceStartMinutes", data.value)} placeholder='' />
          { errors.name && <Label color='red'>{errors.toleranceStartMinutes}</Label>} 

        <Form.Input required error={errors.title} label='Tolerância Adicional Saída' value={group.toleranceEndMinutes} name='toleranceEndMinutes' type='number' onChange={(e, data) => this.handleChange("toleranceEndMinutes", data.value)} placeholder='' />
          { errors.name && <Label color='red'>{errors.toleranceEndMinutes}</Label>} 

        <Form.Field>
          <Radio toggle checked={group.autoCreateUsers} label='Criar Novos Usuários Automaticamente' onChange={(e, data) => this.handleChange("autoCreateUsers", data.checked)} />
        </Form.Field>

           <Form.Field>
            <Radio toggle checked={group.deactivateRemovedUsers} label='Inativar Usuários Removidos' onChange={(e, data) => this.handleChange("deactivateRemovedUsers", data.checked)} />
          </Form.Field>

        <Form.Field>
          <Radio toggle checked={group.syncManager} label='Sincronizar Superiores' onChange={(e, data) => this.handleChange("syncManager", data.checked)} />
        </Form.Field>

        <Form.Field>
          <Radio toggle checked={group.syncPersonalData} label='Atualizar Dados Pessoais' onChange={(e, data) => this.handleChange("syncPersonalData", data.checked)} />
        </Form.Field>

        <h3>Jornada de Trabalho Padrão</h3>
        <Form.Field>
          <Radio toggle checked={group.syncWorkSchedule} label='Sincronizar Jornada de Trabalho' onChange={(e, data) => this.handleChange("syncWorkSchedule", data.checked)} />
        </Form.Field>

        <Grid>
          <Grid.Row>
            <Grid.Column width={4}>Dia da Semana</Grid.Column>
            <Grid.Column width={2}>Entrada</Grid.Column>
            <Grid.Column width={2}>Jornada (minutos)</Grid.Column>
            <Grid.Column width={2}>Almoço (minutos)</Grid.Column>
            <Grid.Column width={2}>Tolerância Entrada (minutos)</Grid.Column>            
            <Grid.Column width={2}>Tolerância Saída (minutos)</Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Segunda-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_1} placeholder='Ex: 08:00' name='start_1' type='text' onChange={(e, data) => this.handleChange("start_1", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_1} name='work_1' type='text' onChange={(e, data) => this.handleChange("work_1", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_1} name='lunch_1' type='text' onChange={(e, data) => this.handleChange("lunch_1", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_1} name='start_tolerance_1' type='text' onChange={(e, data) => this.handleChange("start_tolerance_1", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_1} name='end_tolerance_1' type='text' onChange={(e, data) => this.handleChange("end_tolerance_1", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Terça-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_2}  placeholder='Ex: 08:00' name='start_2' type='text' onChange={(e, data) => this.handleChange("start_2", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_2} name='work_2' type='text' onChange={(e, data) => this.handleChange("work_2", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_2} name='lunch_2' type='text' onChange={(e, data) => this.handleChange("lunch_2", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_2} name='start_tolerance_2' type='text' onChange={(e, data) => this.handleChange("start_tolerance_2", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_2} name='end_tolerance_2' type='text' onChange={(e, data) => this.handleChange("end_tolerance_2", data.value)} />
            </Grid.Column>
          </Grid.Row>        

          <Grid.Row>
            <Grid.Column width={4}>
              Quarta-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_3}  placeholder='Ex: 08:00' name='start_3' type='text' onChange={(e, data) => this.handleChange("start_3", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_3} name='work_3' type='text' onChange={(e, data) => this.handleChange("work_3", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_3} name='lunch_3' type='text' onChange={(e, data) => this.handleChange("lunch_3", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_3} name='start_tolerance_3' type='text' onChange={(e, data) => this.handleChange("start_tolerance_3", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_3} name='end_tolerance_3' type='text' onChange={(e, data) => this.handleChange("end_tolerance_3", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Quinta-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_4}  placeholder='Ex: 08:00' name='start_4' type='text' onChange={(e, data) => this.handleChange("start_4", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_4} name='work_4' type='text' onChange={(e, data) => this.handleChange("work_4", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_4} name='lunch_4' type='text' onChange={(e, data) => this.handleChange("lunch_4", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_4} name='start_tolerance_4' type='text' onChange={(e, data) => this.handleChange("start_tolerance_4", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_4} name='end_tolerance_4' type='text' onChange={(e, data) => this.handleChange("end_tolerance_4", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Sexta-feira
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_5}  placeholder='Ex: 08:00' name='start_5' type='text' onChange={(e, data) => this.handleChange("start_5", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_5} name='work_5' type='text' onChange={(e, data) => this.handleChange("work_5", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_5} name='lunch_5' type='text' onChange={(e, data) => this.handleChange("lunch_5", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_5} name='start_tolerance_5' type='text' onChange={(e, data) => this.handleChange("start_tolerance_5", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_5} name='end_tolerance_5' type='text' onChange={(e, data) => this.handleChange("end_tolerance_5", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Sábado
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_6}  placeholder='Ex: 08:00' name='start_6' type='text' onChange={(e, data) => this.handleChange("start_6", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_6} name='work_6' type='text' onChange={(e, data) => this.handleChange("work_6", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_6} name='lunch_6' type='text' onChange={(e, data) => this.handleChange("lunch_6", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_6} name='start_tolerance_6' type='text' onChange={(e, data) => this.handleChange("start_tolerance_6", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_6} name='end_tolerance_6' type='text' onChange={(e, data) => this.handleChange("end_tolerance_6", data.value)} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={4}>
              Domingo
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_0}  placeholder='Ex: 08:00' name='start_0' type='text' onChange={(e, data) => this.handleChange("start_0", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.work_0} name='work_0' type='text' onChange={(e, data) => this.handleChange("work_0", data.value)} />
            </Grid.Column>            
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.lunch_0} name='lunch_0' type='text' onChange={(e, data) => this.handleChange("lunch_0", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.start_tolerance_0} name='start_tolerance_0' type='text' onChange={(e, data) => this.handleChange("start_tolerance_0", data.value)} />
            </Grid.Column>
            <Grid.Column width={2}>
              <Form.Input size='mini' value={group.end_tolerance_0} name='end_tolerance_0' type='text' onChange={(e, data) => this.handleChange("end_tolerance_0", data.value)} />
            </Grid.Column>
          </Grid.Row>
          
        </Grid>
          <Button type='submit' primary>Salvar</Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, settings } = state

  let props = {
    me: users.me || null,
    subordinates: users.subordinates || [],
    managers: users.managers || null,
    groups: users.groups || null,
    settings: settings ? settings.globalSettings : null,
    users,
    usersLoading: users.loading,
    loading: false
  };

  if (users && users.itemGroup) {
    props.group = users.itemGroup;
  }

  return props;
}

const connectedGroupFormScreen = connect(mapStateToProps)(GroupFormScreen);
export { connectedGroupFormScreen as GroupFormScreen };
